export enum EFlyToCartEvents {
    BEGIN = 'flyToCart:begin',
    COMPLETED = 'flyToCart:completed',
}
